import { colors } from "../colors";
export var TimeEntryType;
(function (TimeEntryType) {
    TimeEntryType["Work"] = "working";
    TimeEntryType["Sick"] = "sick";
    TimeEntryType["Vacation"] = "vacation";
    TimeEntryType["ChildSick"] = "child_sick";
    TimeEntryType["SickInKUG"] = "sick_in_kug";
    TimeEntryType["HourAdjustment"] = "hour_adjustment";
    TimeEntryType["VacationAdjustment"] = "vacation_adjustment";
    TimeEntryType["Free"] = "free";
    TimeEntryType["CompDay"] = "compday";
    TimeEntryType["ResetLedgers"] = "reset_ledgers";
})(TimeEntryType || (TimeEntryType = {}));
export const absenceTypes = [
    TimeEntryType.Sick,
    TimeEntryType.Vacation,
    TimeEntryType.ChildSick,
    TimeEntryType.SickInKUG,
    TimeEntryType.CompDay,
];
export const timeEntryAbsenceTypes = [
    TimeEntryType.Sick,
    TimeEntryType.Vacation,
    TimeEntryType.ChildSick,
    TimeEntryType.SickInKUG,
    TimeEntryType.CompDay,
];
export function timeEntryTypeColor(type) {
    switch (type) {
        case TimeEntryType.Vacation:
            return colors.blue;
        case TimeEntryType.Sick:
        case TimeEntryType.ChildSick:
        case TimeEntryType.SickInKUG:
            return colors.orange;
        case TimeEntryType.Free:
            return colors.grey;
        case TimeEntryType.CompDay:
            return colors.aqua;
        case TimeEntryType.Work:
        case TimeEntryType.HourAdjustment:
        case TimeEntryType.VacationAdjustment:
        case TimeEntryType.ResetLedgers:
        default:
            return "";
    }
}
/**
 * Determines if a time entry represents a half-day absence.
 * A half-day is defined as an entry with a non-null days value that is exactly 0.5.
 *
 * @param entry - An object with a days property (TimeEntry, AbsenceEntry, or similar)
 * @returns true if the entry is a half-day, false otherwise
 */
export function isHalfDayEntry(entry) {
    return !!(entry && entry.days === 0.5);
}
//# sourceMappingURL=time-entry-type.js.map